export const FETCH_ORDERS = 'FETCH_ORDERS';
export type FETCH_ORDERS = typeof FETCH_ORDERS;

export const FETCH_ORDERS_FAILED = 'FETCH_ORDERS_FAILED';
export type FETCH_ORDERS_FAILED = typeof FETCH_ORDERS_FAILED;

export const FETCH_ORDERS_SUCCESS = 'FETCH_ORDERS_SUCCESS';
export type FETCH_ORDERS_SUCCESS = typeof FETCH_ORDERS_SUCCESS;

export const SELECT_ORDER_RECEIPT = 'SELECT_ORDER_RECEIPT';
export type SELECT_ORDER_RECEIPT = typeof SELECT_ORDER_RECEIPT;

export const VIEW_ORDER_RECEIPT = 'VIEW_ORDER_RECEIPT';
export type VIEW_ORDER_RECEIPT = typeof VIEW_ORDER_RECEIPT;

export const CLOSE_ORDER_RECEIPT = 'CLOSE_ORDER_RECEIPT';
export type CLOSE_ORDER_RECEIPT = typeof CLOSE_ORDER_RECEIPT;
